var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHilti1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 21,
    viewBox: "0 0 100 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_374_4617)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0311432 0.325195H99.9688V20.8567H0.0311432V0.325195Z",
    fill: "#CC2229"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.29922 7.29642H30.9113V13.0698H3.29922V7.29642ZM40.9324 10.9998H62.5536V17.372H40.9324V10.9998ZM89.6213 3.2666H96.6468V17.372H89.6213V3.2666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.9324 3.2666H48.5566V17.372H40.9324V3.2666ZM32.1094 3.2666H39.7342V17.372H32.1094V3.2666ZM69.2516 5.66238H76.2771V17.372H69.2516V5.66238Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.4227 3.2666H57.1077V9.69272H88.4227V3.2666ZM3.29922 3.2666H10.8145V17.372H3.29922V3.2666ZM23.4499 3.2666H30.9657V17.372H23.4499V3.2666Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_374_4617"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 20.5931,
    fill: "white",
    transform: "translate(0 0.294434)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHilti1);
export default __webpack_public_path__ + "static/media/hilti-1.ed06a2f4f0b9fe1c28383f73901cac3f.svg";
export { ForwardRef as ReactComponent };